import {axiosSpringInstance} from "../../../ServerApiManager";
import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";

type Variables = {
  agentEmail: string | undefined;
};

type Data = {
  full_name: string | undefined;
};

const getResolutionExpertFullNameByEmail = async (variables: Variables): Promise<Data> => {
  if (!variables.agentEmail) return {full_name: undefined};
  const response = await axiosSpringInstance.get<Data, AxiosResponse<Data>>(
    `/rex-management/resolution-experts/${variables.agentEmail}`
  );
  return response.data;
};

export const useGetResolutionExpertFullNameByEmail = (
  variables: Variables,
  options?: BaseQueryOptions<Data, string>
): BaseUseQueryResult<Data> => {
  return useBaseQuery<Data, Variables>(["rex-full-name"], getResolutionExpertFullNameByEmail, variables, options);
};
